const theme = {
    primary: '#000000',
    secondary: '#00000050',
    accent: '#000000',
    error: '#f56c6c',
    info: '#005daa',
    success: '#22bc70',
    warning: '#fac945',
    border: '#d2d2d7',
    brownishGrey: '#727272',
    brownishGrey2: '#676767',
    brownishGrey3: '#707070',
    slateGrey: '#5f6772',
    slateGrey2: '#606266',
    coolGrey: '#a9aaac',
    brownGrey: '#979797',
    paleGrey: '#f5f5f5',
    paleGrey2: '#f8fdff',
    paleGrey3: '#f1f9ff',
    veryLightBlue: '#d8e9fa',
    veryLightPink: '#f1f1f1',
    clearBlue: '#2699fb',
    cloudyBlue: '#c0c4cc',
    powderBlue: '#bce0fd',
    niceBlue: '#1b75bc',
    deepBlue: '#1a007c',
    darkSkyBlue: '#3c9ee4',
    softBlue: '#4eb4f9',
    lightPink: '#f4eaf0',
    iceBlue: '#e9f5fe',
    blueyGrey: '#909399',
    greyishBrown: '#444444',
    navy: '#031a4e',
    lightPeriwinkle2: '#dcdfe6',
    sapphire: '#1648a7',
    dark: '#31394d',
};

export default theme;
